export const geoCantonShortCodes: Record<string, string> = {
  'geo-canton-zurich': 'ZH',
  'geo-canton-bern': 'BE',
  'geo-canton-luzern': 'LU',
  'geo-canton-uri': 'UR',
  'geo-canton-schwyz': 'SZ',
  'geo-canton-obwalden': 'OW',
  'geo-canton-nidwalden': 'NW',
  'geo-canton-glarus': 'GL',
  'geo-canton-zug': 'ZG',
  'geo-canton-fribourg': 'FR',
  'geo-canton-solothurn': 'SO',
  'geo-canton-basel-stadt': 'BS',
  'geo-canton-basel-landschaft': 'BL',
  'geo-canton-schaffhausen': 'SH',
  'geo-canton-appenzell-ausserrhoden': 'AR',
  'geo-canton-appenzell-innerrhoden': 'AI',
  'geo-canton-st-gallen': 'SG',
  'geo-canton-graubunden': 'GR',
  'geo-canton-aargau': 'AG',
  'geo-canton-thurgau': 'TG',
  'geo-canton-ticino': 'TI',
  'geo-canton-vaud': 'VD',
  'geo-canton-valais': 'VS',
  'geo-canton-neuchatel': 'NE',
  'geo-canton-geneve': 'GE',
  'geo-canton-jura': 'JU',
};

export const geoTagToCanton = (tag: string | undefined): string =>
  geoCantonShortCodes[tag || ''] || '';

// predicate for array.find()
export const cantonInGeoTags = (tag: string): boolean => tag.startsWith('geo-canton-');
